import { render, staticRenderFns } from "./LawMatterTypeSubFolderList.vue?vue&type=template&id=f35d6184&"
import script from "./LawMatterTypeSubFolderList.vue?vue&type=script&lang=js&"
export * from "./LawMatterTypeSubFolderList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterTypeSubFolderList.vue?vue&type=style&index=0&id=f35d6184&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports